import styled from '@emotion/styled';
import { Info } from '@styled-icons/material-outlined/Info';
import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled } from '@naf-simba/theme';
import { nafColor } from '@nafcore/theme';
import { GridCol } from '@naf/grid';
import { breakpoints, spacing } from '@naf/theme';
import { Text } from '@naf/text';
import { HR_COLOR } from '../../styles/colors';

const Wrapper = styled(GridCol)`
  display: flex;
  flex-direction: column;
`;

const HRLine = styled.hr`
  border: 0;
  border-top: 3px solid ${HR_COLOR};
  width: 96px;
  margin: 0 0 ${spacing.space32};
  color: ${HR_COLOR};

  @media (max-width: ${breakpoints.s}) {
    margin-bottom: ${spacing.space48};
  }
`;

const Title = styled.strong`
  font-weight: 500;
`;

const Img = styled.img`
  height: ${spacing.space160};
  width: ${spacing.space160};
  flex-shrink: 0;
`;

const ResponseMsg = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing.space24};

  @media (max-width: ${breakpoints.m}) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing.space16};
  }
`;

const FormButtonWrapper = styled.div`
  margin-top: ${spacing.space32};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.space8};
`;

const ThankYouButtonWrapper = styled.div<{ $hasSuggested: boolean }>`
  display: flex;
  align-items: center;
  flex-basis: 100%;
  margin-top: ${({ $hasSuggested }) => ($hasSuggested ? spacing.space24 : spacing.space16)};

  @media (max-width: ${breakpoints.m}) {
    margin-top: 0;
  }
`;

const DecorativeColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;

  ${HRLine} {
    margin-bottom: ${spacing.space8};
  }
`;

const TextAreaInfo = styled.div`
  display: flex;
  align-items: center;
  margin-top: -${spacing.space4};

  svg {
    margin-right: ${spacing.space8};
  }

  p {
    margin: 0;
  }
`;

const StyledTextArea = styled.div`
  > div {
    max-width: 100%;
  }
`;

const ResponseText = styled(Text)`
  margin-bottom: ${spacing.space8};
`;

const ResponseContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

const ResponseHeading = styled(Text)`
  margin: 0;
  line-height: 1.25;
`;

const ResponseBody = styled(Text)`
  margin: 0;
  line-height: 1.35;
  display: flex;
  align-items: center;
`;

const ContactButton = simbaStyled(Button)(() => ({
  '&&': {
    whiteSpace: 'nowrap',
    alignSelf: 'flex-start',
    flexShrink: 0,
  },
}));

const StyledIcon = styled(Info)`
  color: ${nafColor.information.information};
`;

const SuggestedResponse = styled.div``;

const ErrorMessage = styled(Text)`
  color: ${nafColor.information.errorDark};
`;

const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  gap: ${spacing.space24};
  margin-top: ${spacing.space12};

  @media (max-width: ${breakpoints.s}) {
    margin-top: ${spacing.space16};
  }
`;

export default {
  Wrapper,
  Form,
  HRLine,
  Title,
  ThankYouButtonWrapper,
  FormButtonWrapper,
  Img,
  ResponseMsg,
  DecorativeColumn,
  ResponseContent,
  ResponseHeading,
  ResponseBody,
  StyledTextArea,
  TextAreaInfo,
  ResponseText,
  StyledIcon,
  SuggestedResponse,
  ContactButton,
  ErrorMessage,
};
